import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { getInlineLoader, setCookie } from "../Helpers";
import {
	STR_AGENCY_REPORTS,
	STR_AGENT_REQUESTS_HISTORY,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_LINK_SUPERVISOR,
	STR_LOGOUT,
	STR_MY_COACH,
	STR_MY_CREATED_AGENT_REQUESTS,
	STR_MY_PARTICIPATED_AGENT_REQUESTS,
	STR_MY_PROCESSED_AGENT_REQUESTS,
	STR_MY_REVENUES,
	STR_MY_STUDENTS,
	STR_MY_SUBSCRIPTION,
	STR_OTHER_SETTINGS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_PLEASE_CONTACT_SUPPORT_TO_BECOME_RIDER,
	STR_RIDER_DASHBOARD,
	STR_SELECT_ACCOUNT_TO_MANAGE,
	STR_SET_CURRENCY,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_USER_REPORT,
	STR_VERIFY_YOUR_PROFILE,
	STR_WHATSAPP_SETUP,
	STR_YOUR_PROFILE,
	STR_YOUR_REPORTS
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdAnalytics, MdContactPage, MdCreditCard, MdDashboard, MdDetails, MdInfoOutline, MdLink, MdLogout, MdOutlineDashboard, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdOutlineWarning, MdPerson, MdSupervisorAccount, MdSupportAgent, MdTranslate, MdVerified, MdWallet, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import { FaRegUser } from "react-icons/fa";
import { RiListCheck2, RiListCheck3, RiListOrdered, RiProfileLine } from "react-icons/ri";
import { LiaUserSolid } from "react-icons/lia";
import { IoWarningOutline } from "react-icons/io5";
import OneRiderAccount from '../ones/OneRiderAccount';

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getMyRiderAccounts(),
		])
		setReady(true);
	}

	

	useEffect(() => {
		init();
	}, [])



	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						<div className="col-md-12">
													
							<h6 className="main-section-title">
								{STR_RIDER_DASHBOARD[appContext.language]}
								
							</h6>
								
						</div>

						<div className="col-md-12">
							{
								(appContext.myRiderAccounts && appContext.myRiderAccounts.length > 0) ?
								<div className="">
									<h6
										style={{
											fontSize: "14px"
										}}
										className="text-muted mb-2"
									>
										{STR_SELECT_ACCOUNT_TO_MANAGE[appContext.language]}
									</h6>

									{
										appContext.myRiderAccounts.map((item, i) => {
											return (
												<OneRiderAccount data={item} key={i}/>
											)
										})
									}
								</div>
								:
								<div className="text-center bg-surface">

									
									<h6
										className="font-semi-bold"
										style={{
											padding: "40px",
											fontSize: "18px"
										}}
									>
										<IoWarningOutline className="mb-3 text-secondary" size={52}/>

										<br/>

										{STR_PLEASE_CONTACT_SUPPORT_TO_BECOME_RIDER[appContext.language]}
									</h6>

									<button
										className="btn btn-primary btn-rounded mb-4"
										onClick={() => {
                      appContext.navTo({
                        item: 'view',
                        subItem: 'contact_us',
                      })
                    }}
									>
										{STR_CONTACT_US[appContext.language]}
									</button>
								</div>
							}
						</div>


					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}